import React from "react";
// import PropTypes from "prop-types";
import Tiles from "./Tiles";

function Board({ handleSquareClick, board, winningSquares }) {
	const renderTiles = (position) => {
		const isWinSquares = winningSquares.includes(position);

		return (
			<Tiles
				value={board[position]}
				handleClick={() => {
					handleSquareClick(position);
				}}
				isWinSquares={isWinSquares}
			/>
		);
	};

	return (
		<div className="board">
			<div className="board-row">
				{renderTiles(0)}
				{renderTiles(1)}
				{renderTiles(2)}
			</div>
			<div className="board-row">
				{renderTiles(3)}
				{renderTiles(4)}
				{renderTiles(5)}
			</div>
			<div className="board-row">
				{renderTiles(6)}
				{renderTiles(7)}
				{renderTiles(8)}
			</div>
		</div>
	);
}

// Board.propTypes = {};

export default Board;
